var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInnerBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.330078,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#326FAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40234 6.91155C7.31358 6.91155 7.24163 6.98351 7.24163 7.07227V28.9294C7.24163 29.0182 7.31358 29.0901 7.40234 29.0901H29.2595C29.3482 29.0901 29.4202 29.0182 29.4202 28.9294V7.07227C29.4202 6.98351 29.3482 6.91155 29.2595 6.91155H7.40234ZM6.27734 7.07227C6.27734 6.45095 6.78102 5.94727 7.40234 5.94727H29.2595C29.8808 5.94727 30.3845 6.45095 30.3845 7.07227V28.9294C30.3845 29.5507 29.8808 30.0544 29.2595 30.0544H7.40234C6.78102 30.0544 6.27734 29.5507 6.27734 28.9294V7.07227Z",
    fill: "#326FAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7595 11.5723V24.4294H11.9023V11.5723H24.7595Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4199 11.0898H12.8664V12.0541H12.3842V12.5363H11.4199V11.0898ZM14.1521 11.0898H16.0806V12.0541H14.1521V11.0898ZM17.3664 11.0898H19.2949V12.0541H17.3664V11.0898ZM20.5806 11.0898H22.5092V12.0541H20.5806V11.0898ZM23.7949 11.0898H25.2414V12.5363H24.2771V12.0541H23.7949V11.0898ZM11.4199 15.7506V13.822H12.3842V15.7506H11.4199ZM25.2414 13.822V15.7506H24.2771V13.822H25.2414ZM11.4199 18.9648V17.0363H12.3842V18.9648H11.4199ZM25.2414 17.0363V18.9648H24.2771V17.0363H25.2414ZM11.4199 22.1791V20.2506H12.3842V22.1791H11.4199ZM25.2414 20.2506V22.1791H24.2771V20.2506H25.2414ZM11.4199 23.4648H12.3842V23.947H12.8664V24.9113H11.4199V23.4648ZM24.2771 23.947V23.4648H25.2414V24.9113H23.7949V23.947H24.2771ZM16.0806 24.9113H14.1521V23.947H16.0806V24.9113ZM19.2949 24.9113H17.3664V23.947H19.2949V24.9113ZM22.5092 24.9113H20.5806V23.947H22.5092V24.9113Z",
    fill: "#326FAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7584 10.2852C25.4685 10.2852 26.0441 10.8607 26.0441 11.5709C26.0441 12.281 25.4685 12.8566 24.7584 12.8566C24.0482 12.8566 23.4727 12.281 23.4727 11.5709C23.4727 10.8607 24.0482 10.2852 24.7584 10.2852Z",
    fill: "#F3F6F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7581 10.767C24.3142 10.767 23.9545 11.1267 23.9545 11.5706C23.9545 12.0145 24.3142 12.3742 24.7581 12.3742C25.202 12.3742 25.5617 12.0145 25.5617 11.5706C25.5617 11.1267 25.202 10.767 24.7581 10.767ZM22.9902 11.5706C22.9902 10.5942 23.7817 9.80273 24.7581 9.80273C25.7345 9.80273 26.5259 10.5942 26.5259 11.5706C26.5259 12.547 25.7345 13.3384 24.7581 13.3384C23.7817 13.3384 22.9902 12.547 22.9902 11.5706Z",
    fill: "#326FAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7584 23.1426C25.4685 23.1426 26.0441 23.7181 26.0441 24.4283C26.0441 25.1384 25.4685 25.714 24.7584 25.714C24.0482 25.714 23.4727 25.1384 23.4727 24.4283C23.4727 23.7181 24.0482 23.1426 24.7584 23.1426Z",
    fill: "#F3F6F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7581 23.6244C24.3142 23.6244 23.9545 23.9842 23.9545 24.428C23.9545 24.8719 24.3142 25.2316 24.7581 25.2316C25.202 25.2316 25.5617 24.8719 25.5617 24.428C25.5617 23.9842 25.202 23.6244 24.7581 23.6244ZM22.9902 24.428C22.9902 23.4516 23.7817 22.6602 24.7581 22.6602C25.7345 22.6602 26.5259 23.4516 26.5259 24.428C26.5259 25.4044 25.7345 26.1959 24.7581 26.1959C23.7817 26.1959 22.9902 25.4044 22.9902 24.428Z",
    fill: "#326FAE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9009 10.2852C12.6111 10.2852 13.1867 10.8607 13.1867 11.5709C13.1867 12.281 12.6111 12.8566 11.9009 12.8566C11.1908 12.8566 10.6152 12.281 10.6152 11.5709C10.6152 10.8607 11.1908 10.2852 11.9009 10.2852Z",
    fill: "#F3F6F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9007 10.767C11.4568 10.767 11.0971 11.1267 11.0971 11.5706C11.0971 12.0145 11.4568 12.3742 11.9007 12.3742C12.3445 12.3742 12.7042 12.0145 12.7042 11.5706C12.7042 11.1267 12.3445 10.767 11.9007 10.767ZM10.1328 11.5706C10.1328 10.5942 10.9242 9.80273 11.9007 9.80273C12.8771 9.80273 13.6685 10.5942 13.6685 11.5706C13.6685 12.547 12.8771 13.3384 11.9007 13.3384C10.9242 13.3384 10.1328 12.547 10.1328 11.5706Z",
    fill: "#326FAE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9009 23.1426C12.6111 23.1426 13.1867 23.7181 13.1867 24.4283C13.1867 25.1384 12.6111 25.714 11.9009 25.714C11.1908 25.714 10.6152 25.1384 10.6152 24.4283C10.6152 23.7181 11.1908 23.1426 11.9009 23.1426Z",
    fill: "#F3F6F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9007 23.6244C11.4568 23.6244 11.0971 23.9842 11.0971 24.428C11.0971 24.8719 11.4568 25.2316 11.9007 25.2316C12.3445 25.2316 12.7042 24.8719 12.7042 24.428C12.7042 23.9842 12.3445 23.6244 11.9007 23.6244ZM10.1328 24.428C10.1328 23.4516 10.9242 22.6602 11.9007 22.6602C12.8771 22.6602 13.6685 23.4516 13.6685 24.428C13.6685 25.4044 12.8771 26.1959 11.9007 26.1959C10.9242 26.1959 10.1328 25.4044 10.1328 24.428Z",
    fill: "#326FAE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnerBorder);
export default __webpack_public_path__ + "static/media/inner-border.8ccd302694656814899ec387d26860a6.svg";
export { ForwardRef as ReactComponent };